module.exports = __webpack_public_path__ + "img/vestur.30dea097.svg";